import { useState, useCallback, useEffect } from 'react';
import { useWebSocket } from '../hooks/useWebSocket';
export default function PlayerPhone({onBack}){
  const [phase,setPhase]=useState('join');
  const [codeInput,setCodeInput]=useState('');
  const [nameInput,setNameInput]=useState('');
  const [error,setError]=useState('');
  const [myName,setMyName]=useState('');
  const [question,setQuestion]=useState(null);
  const [sel,setSel]=useState(null);
  const [result,setResult]=useState(null);
  const [score,setScore]=useState(0);
  const [roundResult,setRoundResult]=useState(null);
  const [gameOver,setGameOver]=useState(null);
  const [gameType,setGameType]=useState('');
  const [waiting,setWaiting]=useState(false);
  const sendRef={current:null};
  const onMsg=useCallback((msg)=>{
    switch(msg.type){
      case 'JOINED': setMyName(msg.name);setPhase('lobby');setError('');break;
      case 'ERROR': setError(msg.message);break;
      case 'GAME_STARTED': setGameType(msg.game);setPhase('waiting');setQuestion(null);setSel(null);setResult(null);setRoundResult(null);break;
      case 'QUESTION': setQuestion(msg.question);setSel(null);setResult(null);setRoundResult(null);setPhase('question');setWaiting(false);break;
      case 'ANSWER_RECEIVED': setWaiting(true);break;
      case 'ROUND_RESULT': {
        const me=msg.results?.find(r=>r.name===myName);
        setRoundResult(msg);if(me)setScore(me.score);setPhase('result');setWaiting(false);break;
      }
      case 'GAME_OVER': setGameOver(msg);setPhase('gameover');break;
      case 'BACK_TO_LOBBY': setPhase('lobby');setQuestion(null);setSel(null);setResult(null);setGameOver(null);break;
      case 'KICKED': setPhase('kicked');break;
      case 'HOST_LEFT': setPhase('hostleft');break;
    }
  },[myName]);
  const {send}=useWebSocket(onMsg);
  useEffect(()=>{sendRef.current=send;},[send]);
  const join=useCallback(()=>{
    const code=codeInput.trim().toUpperCase();
    const name=nameInput.trim();
    if(!code||code.length!==4){setError('Enter the 4-letter code');return;}
    if(!name){setError('Enter your name');return;}
    send('JOIN_SESSION',{code,name});
  },[codeInput,nameInput,send]);
  const answer=useCallback((ans)=>{
    if(sel!==null||waiting)return;setSel(ans);send('SUBMIT_ANSWER',{answer:ans});
  },[sel,waiting,send]);
  if(phase==='kicked')return(<div className="layer phone-wrap"><div className="phone-waiting"><div className="phone-icon">🚫</div><h2 style={{color:'#f87171'}}>You were removed</h2><button className="btn-blue" onClick={onBack}>Back to Menu</button></div></div>);
  if(phase==='hostleft')return(<div className="layer phone-wrap"><div className="phone-waiting"><div className="phone-icon">👋</div><h2 style={{color:'#8ba3cc'}}>Host ended the session</h2><button className="btn-blue" onClick={onBack}>Back to Menu</button></div></div>);
  if(phase==='gameover'&&gameOver)return(<div className="layer phone-wrap"><div className="over-card">
    <div className="over-tag" style={{color:'#38bdf8',border:'1px solid #0369a1'}}>GAME OVER</div>
    <h1 className="over-h1">Final Scores</h1>
    <div className="pq-scoreboard" style={{width:'100%'}}>
      {gameOver.final.map((p,i)=><div key={i} className="pq-score-row">
        <span className="pq-score-pos">{i===0?'🏆':i===1?'🥈':i===2?'🥉':('#'+(i+1))}</span>
        <span className="pq-score-name" style={{color:p.name===myName?'#38bdf8':'#e8edf8'}}>{p.name}{p.name===myName?' (you)':''}</span>
        <span className="pq-score-pts">{p.score}</span>
      </div>)}
    </div>
    <button className="btn-blue" onClick={onBack}>Back to Menu</button>
  </div></div>);
  return(<div className="layer" style={{display:'flex',flexDirection:'column',minHeight:'100vh'}}>
    <div className="g-hdr">
      <button className="g-back" onClick={onBack}>← Menu</button>
      <div className="g-title blue">JOIN GAME</div>
      {myName&&<div className="g-pills"><div className="g-pill b"><span className="g-plbl">Score</span><span className="g-pval">{score}</span></div></div>}
    </div>
    {phase==='join'&&<div className="join-wrap"><div className="join-card">
      <div className="join-title">JOIN GAME</div>
      <p style={{fontSize:'0.74rem',color:'#8ba3cc'}}>Enter the 4-letter code from the host screen</p>
      <input className="join-input" value={codeInput} onChange={e=>setCodeInput(e.target.value.toUpperCase().slice(0,4))} placeholder="CODE" maxLength={4}/>
      <input className="join-name-input" value={nameInput} onChange={e=>setNameInput(e.target.value.slice(0,16))} placeholder="Your name"/>
      {error&&<div className="join-error">{error}</div>}
      <button className="btn-blue" onClick={join}>JOIN</button>
    </div></div>}
    {phase==='lobby'&&<div className="phone-wrap"><div className="phone-waiting">
      <div className="phone-icon">⏳</div>
      <h2 style={{color:'#38bdf8'}}>Hi, {myName}!</h2>
      <p className="phone-status">Waiting for host to start the game...</p>
    </div></div>}
    {phase==='waiting'&&<div className="phone-wrap"><div className="phone-waiting">
      <div className="phone-icon">⏳</div>
      <p className="phone-status">Waiting for question...</p>
    </div></div>}
    {phase==='question'&&question&&<div className="game-body" style={{alignItems:'center',maxWidth:400}}>
      {question.type==='flag'&&<div className="phone-flag">{question.flag}</div>}
      {question.text&&<div className="qcard" style={{width:'100%'}}><div className="qcard-q">{question.text}</div></div>}
      {waiting?<div className="phone-waiting"><div className="phone-icon">✓</div><p className="phone-status">Answer submitted! Waiting...</p></div>:
      <div className="phone-choices">{(question.opts||[]).map((o,i)=><button key={i} className={'phone-choice'+(sel===o?' chosen':'')} onClick={()=>answer(o)} disabled={sel!==null}>{o}</button>)}</div>}
    </div>}
    {phase==='result'&&roundResult&&<div className="phone-wrap"><div style={{textAlign:'center',display:'flex',flexDirection:'column',gap:14,alignItems:'center'}}>
      {(()=>{const me=roundResult.results?.find(r=>r.name===myName);return me?(<>
        <div className={'result-box '+(me.correct?'ok':'no')} style={{minWidth:220}}>
          <div className={'result-head '+(me.correct?'ok':'no')}>{me.correct?(me.first?'FIRST! +'+me.pts+' pts':'Correct! +'+me.pts+' pts'):'Wrong!'}</div>
          <div className="result-detail">Answer: {roundResult.correctAnswer}</div>
        </div>
        <div className="phone-score">{me.score}</div>
        <div className="phone-score-label">Your Total</div>
        <p style={{fontSize:'0.72rem',color:'#8ba3cc'}}>Waiting for next question...</p>
      </>):null;})()}
    </div></div>}
  </div>);
}
